import { render, staticRenderFns } from "./nihao.vue?vue&type=template&id=265622eb&scoped=true"
import script from "./nihao.vue?vue&type=script&lang=js"
export * from "./nihao.vue?vue&type=script&lang=js"
import style0 from "./nihao.vue?vue&type=style&index=0&id=265622eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265622eb",
  null
  
)

export default component.exports